import React from 'react'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import { PathValidationErrorFragment, PathValidationErrorTag } from '#src/generated/graphql'
import { Link } from 'react-router-dom'
import { Notification } from '@deal/components'
import styles from './styles.css'

interface PathErrorProps {
  pathSlug: string
  pageSlug: string
  pathFlowId: string
}

interface ErrorProps extends PathErrorProps {
  errors: PathValidationErrorFragment[]
}

interface ErrorTagsProps extends PathErrorProps {
  tags: PathValidationErrorTag[]
}

const ErrorTags: React.SFC<ErrorTagsProps> = ({ tags, pathSlug, pageSlug, pathFlowId }) => {
  return (
    <>
      {tags.map((tag: string, idx: number) => {
        switch (tag) {
          case PathValidationErrorTag.REQUIRES_LOGIN_TO_PROCEED:
            const thenLink = `?then=${encodeURIComponent(
              `/requests/reenter/${pathSlug}/${pageSlug}?flowId=${pathFlowId}`
            )}`

            return (
              <Link to={`/auth/login${thenLink}`} key={idx} className={styles.logIn}>
                Log In
              </Link>
            )

          default:
            return null
        }
      })}
    </>
  )
}

const ErrorHeader: React.SFC<ErrorProps> = ({ errors, ...rest }) => {
  return (
    <>
      {errors.map((error, idx: number) => {
        return (
          <div data-testid="error-header">
            <Notification key={idx} type="error" className={styles.notifications}>
              {error.message && <AttributedHtmlText text={error.message} />}
              {error.tags && error.tags.length > 0 && <ErrorTags tags={error.tags} {...rest} />}
            </Notification>
          </div>
        )
      })}
    </>
  )
}

export default ErrorHeader
